package com.merkost.handpass.admin.components

import androidx.compose.runtime.Composable
import com.merkost.handpass.admin.contract.AsyncSection
import com.merkost.handpass.sharedweb.theme.HandpassSpacing
import org.jetbrains.compose.web.dom.Div

@Composable
fun <R> AdminListSection(
    title: String?,
    count: Int?,
    data: AsyncSection<List<R>>,
    emptyTitle: String,
    emptyMessage: String? = null,
    skeletonRows: Int = 8,
    onRetry: () -> Unit,
    content: @Composable (List<R>) -> Unit,
) {
    AdminPanel(title = title, count = count, flush = true) {
        when (data) {
            AsyncSection.Loading -> Div({ style { property("padding", "${HandpassSpacing.Default}") } }) {
                AdminSkeletonTable(rows = skeletonRows)
            }
            is AsyncSection.Failed -> AdminEmptyState(
                title = "Failed to load",
                description = data.message,
                actionLabel = "Retry",
                onAction = onRetry,
            )
            is AsyncSection.Loaded -> {
                if (data.value.isEmpty()) {
                    AdminEmptyState(title = emptyTitle, description = emptyMessage)
                } else {
                    content(data.value)
                }
            }
        }
    }
}
